var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"iconify-icon"},[_c('icon',_vm._b({style:({ fontSize: `${_vm.size}px` }),attrs:{"icon":_vm.icon}},'icon',_vm.$attrs,false)),(_vm.badge)?_c('span',{class:['badge badge-up badge-pill', _vm.badgeClasses]},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }